import React from 'react'
import { useLuxLabel, useLuxMeasure } from '@moonpig/web-core-utils'
import {
  ProductModalProvider,
  RecentlyViewedProvider,
  FavouritesProvider,
  PageTypeEnum,
} from '@moonpig/web-shared-products'
import { Home } from '../../components/Home'
import { PageContent, ContentModule } from '../../types'
import { useLuxAddExperimentData } from '../../utils'
import type { RemindersQueryResult } from '../ContentPage/remindersQuery'

export type HomePageProps = {
  modules: ContentModule[]
  remindersResult?: RemindersQueryResult
}

export const HomePage: PageContent<HomePageProps> = ({
  modules,
  remindersResult,
}) => {
  const clientSideRoutingEnabled = false
  const luxAbTestCustomData = [
    {
      name: 'clientSideRouting',
      value: clientSideRoutingEnabled.toString(),
    },
  ]

  useLuxLabel('Homepage Page')
  useLuxMeasure(clientSideRoutingEnabled)
  useLuxAddExperimentData(luxAbTestCustomData)

  return (
    <RecentlyViewedProvider>
      <FavouritesProvider location="Home" enableToastNotification>
        <ProductModalProvider
          context={{ location: 'Home', pageType: PageTypeEnum.HOME }}
        >
          <Home modules={modules} remindersResult={remindersResult} />
        </ProductModalProvider>
      </FavouritesProvider>
    </RecentlyViewedProvider>
  )
}

HomePage.getInitialProps = async ({ modules, remindersResult }) => {
  return {
    props: {
      modules,
      remindersResult,
    },
    pageOptions: {
      tracking: {
        type: 'home',
      },
    },
  }
}
